import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Ödeme planlama olayları. Yükler KİŞİSEL VERİ ve IBAN TAŞIMAZ (kiracıdaki tüm oturumlara gidebilirler);
 * istemci ayrıntıyı yetki denetimli `/payment-batches/:id` ucundan çeker.
 */
const batchPayload = {
    batchId: z.uuid(),
    batchNo: z.string(),
    companyId: z.uuid(),
    paymentDate: z.iso.date(),
    /** Kuruş (dizge). */
    totalAmount: z.string(),
    lineCount: z.number().int(),
};
export const paymentBatchSubmittedV1 = defineEvent({
    type: "payments.batch.submitted",
    version: 1,
    description: "Ödeme partisi onaya gönderildi (politika yoksa aynı anda onaylanır)",
    realtime: ["tenant"],
    payload: z.object({
        ...batchPayload,
        approvalStatus: z.enum(["PENDING", "AUTO_APPROVED"]),
        approvalRequestId: z.uuid(),
    }),
});
export const paymentBatchApprovedV1 = defineEvent({
    type: "payments.batch.approved",
    version: 1,
    description: "Ödeme partisi onaylandı; yürütmeye hazır",
    realtime: ["tenant"],
    payload: z.object(batchPayload),
});
export const paymentBatchExecutedV1 = defineEvent({
    type: "payments.batch.executed",
    version: 1,
    description: "Ödeme partisi yürütüldü (başarısız satırlar ayrıca raporlanır)",
    realtime: ["tenant"],
    payload: z.object({
        ...batchPayload,
        paidCount: z.number().int(),
        failedCount: z.number().int(),
        /** Kuruş (dizge): gerçekten ödenen toplam. */
        paidAmount: z.string(),
    }),
});
//# sourceMappingURL=payments.v1.js.map